import React from 'react';
import CampaignCreativeFields, { CampaignCreativeModals } from '../../Pages/Admin/AdminDashboardAdvertisers/CreateCampaign/CampaignCreativeFields';
import '../../Pages/Advertiser/AdvertiserDashboard/AdvertiserDashboardNewCampaign/AdvertiserDashboardNewCampaign.css';

export default function CampaignContentUploadForm({
    inputIds,
    creativeHook,
    submitLabel,
    onSubmit,
    submitting,
    error,
    onCancel,
    cancelLabel = 'Cancel',
}) {
    const {
        campaignHorizontalContent,
        campaignVerticalContent,
        creativeEditor,
        cropExporting,
        creativeFileNames,
        creativeProcessing,
        processCreativeUpload,
        handleCreativeEditorCancel,
        handleCropNext,
        handlePreviewNext,
    } = creativeHook;

    return (
        <div className="campaignContentUploadForm">
            <CampaignCreativeModals
                creativeEditor={creativeEditor}
                cropExporting={cropExporting}
                onCancel={handleCreativeEditorCancel}
                onCropNext={handleCropNext}
                onPreviewNext={handlePreviewNext}
            />

            <CampaignCreativeFields
                inputIds={inputIds}
                creativeFileNames={creativeFileNames}
                campaignHorizontalContent={campaignHorizontalContent}
                campaignVerticalContent={campaignVerticalContent}
                creativeProcessing={creativeProcessing}
                onHorizontalChange={(e) => processCreativeUpload(e, 'horizontal')}
                onVerticalChange={(e) => processCreativeUpload(e, 'vertical')}
            />

            {error && <p className="adminCreateCampaignError">{error}</p>}

            <div className="campaignActionsRow">
                {onCancel && (
                    <button type="button" className="denyBtnCampaignDetails userDetailsBtn" onClick={onCancel} disabled={submitting}>
                        {cancelLabel}
                    </button>
                )}
                <button
                    type="button"
                    className="approveBtn userDetailsBtn"
                    onClick={() => onSubmit({ campaignHorizontalContent, campaignVerticalContent })}
                    disabled={
                        submitting
                        || Boolean(creativeProcessing)
                        || !campaignHorizontalContent
                        || !campaignVerticalContent
                    }
                >
                    {submitting ? 'Saving…' : submitLabel}
                </button>
            </div>
        </div>
    );
}
